import HotelList from "../components/HotelList";
import { Helmet } from "react-helmet-async";

export default function Hotels() {
    return (

        <>
            <Helmet>
                {/* Basic SEO */}
                <title>Hotels in UAE | UAE Dubai Hotels</title>

                <meta
                    name="description"
                    content="Discover the best hotels across Dubai, Abu Dhabi, Sharjah, Ras Al Khaimah, Ajman, Fujairah, and the UAE. Compare luxury, budget, family, business, and beachfront hotels at competitive prices with UAE Dubai Hotels."
                />

                <meta
                    name="keywords"
                    content="UAE Dubai Hotels, hotels in UAE, Dubai hotels, Abu Dhabi hotels, Sharjah hotels, Ras Al Khaimah hotels, Ajman hotels, Fujairah hotels, luxury hotels UAE, budget hotels UAE, family hotels Dubai, hotel booking UAE, best hotels UAE"
                />

                <meta name="robots" content="index, follow" />
                <meta name="author" content="UAE Dubai Hotels" />

                {/* Canonical */}
                <link
                    rel="canonical"
                    href="https://uaedubaihotels.com/hotels"
                />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="UAE Dubai Hotels" />
                <meta property="og:locale" content="en_US" />

                <meta
                    property="og:title"
                    content="Hotels in UAE | UAE Dubai Hotels"
                />

                <meta
                    property="og:description"
                    content="Explore luxury, business, family, beachfront, and budget hotels across the UAE. Compare prices and book your perfect stay with UAE Dubai Hotels."
                />

                <meta
                    property="og:url"
                    content="https://uaedubaihotels.com/hotels"
                />

                <meta
                    property="og:image"
                    content="https://uaedubaihotels.com/images/default-og.png"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Hotels in UAE | UAE Dubai Hotels"
                />

                <meta
                    name="twitter:description"
                    content="Browse the best hotels in Dubai and across the UAE. Find luxury resorts, affordable stays, and exclusive hotel deals with UAE Dubai Hotels."
                />

                <meta
                    name="twitter:image"
                    content="https://uaedubaihotels.com/images/default-og.png"
                />
            </Helmet>

            <div>
                <HotelList showSidebar={true} showBanner={true} showHeading={false} />
            </div>
        </>
    );
}